export default "__VITE_ASSET__Bwpg9WvZ__"